import { schema } from "normalizr";

const expenseCategory = new schema.Entity(`expense_categories`);
const arrayOfExpenseCategories = [expenseCategory];

export { expenseCategory, arrayOfExpenseCategories };
